import axios from "../axios";
import * as fetchResponseHandling from "./../responseHandling/fetch"
import * as updateResponseHandling from "./../responseHandling/update"

async function fetchLibrary(libraryId) {
  const res = await axios.get(`/libraries/${libraryId}`);
  return fetchResponseHandling.parseResponse(res);
}

async function updateLibrary(libraryId, body) {
  const res = await axios.put(`/libraries/${libraryId}`, body);
  return updateResponseHandling.parseResponse(res);
}

async function getTeacherLibrary() {
  const res = await axios.get(`/teachers/libraries`);
  return fetchResponseHandling.parseResponse(res);
}

export {
  fetchLibrary,
  updateLibrary,
  getTeacherLibrary,
};